<template>
    <div>
        <v-btn
            icon
            x-large
            class='mx-2'
            @click='openAddToBookmarkDialog(ad)'
        >
            <v-icon
                v-if='isStar(ad._id)'
                class='mx-1'
                color='yellow accent-4'
            >
                mdi-star
            </v-icon>
            <v-icon
                v-else class='mx-1'
                color='cyan lighten-5'
            >
                mdi-star-outline
            </v-icon>
        </v-btn>
        <!--bookmark dialog-->
        <v-dialog
            v-if='selectedAd'
            v-model='addBookmarkDialog'
            max-width='320'
            persistent
            scrollable
        >
            <v-card>
                <v-card-title class='subtitle-1'>
                    <span v-if='!isStar(selectedAd._id)'>نشان کردن آگهی</span>
                    <span v-else>حذف آگهی نشان شده</span>
                </v-card-title>
                <v-card-text v-if='!isStar(selectedAd._id)'>
                    <v-textarea
                        id='note'
                        dense
                        filled
                        :rows='3'
                        auto-grow
                        placeholder='ثبت یادداشت برای آگهی'
                        hide-details
                        elevation='0'
                        v-model='bookmarkNote'
                    >
                    </v-textarea>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-btn
                        outlined
                        @click='addBookmarkDialog = false'
                    >
                        لغو
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        v-if='isStar(selectedAd._id)'
                        color='error'
                        @click='removeFromBookmarks(selectedAd._id)'
                    >
                        حذف
                    </v-btn>
                    <v-btn
                        v-else
                        color='primary'
                        @click='addToBookmarks(selectedAd,bookmarkNote)'
                    >
                        نشان کردن
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "BookMarkAd",
    props: {
        ad: Object,
        realEstate: Object
    },
    data() {
        return {
            selectedAd: null,
            addBookmarkDialog: false,
            bookmarkNote: null
        }
    },
    methods: {
        openAddToBookmarkDialog(item) {
            this.selectedAd = item;
            this.addBookmarkDialog = true;
        },
        addToBookmarks(selectedAd) {
            const bookmark = {...selectedAd, note: this.bookmarkNote};
            this.setBookmark(bookmark);
            this.$snackbar.showMessage(
                {
                    content: 'آگهی نشان شد',
                    color: 'success'
                }
            );
            this.bookmarkNote = '';
            this.addBookmarkDialog = false;
        },
        removeFromBookmarks(ad_id) {
            this.$snackbar.showMessage(
                {
                    content: 'آگهی نشان شده، حذف شد',
                    color: 'success'
                }
            );
            this.removeItemFromBookmarks(ad_id);
            this.addBookmarkDialog = false;
        },
        ...mapActions(['setBookmark', 'removeItemFromBookmarks'])
    },
    computed: {
        isStar() {
            return (ad_id) => {
                const isBookmarked = this.bookmarks.filter(item => item._id === ad_id);
                return isBookmarked.length > 0;
            };
        },
        ...mapState(['bookmarks'])
    },
    created() {
    }

}
</script>

<style scoped>

</style>